import { resolve } from 'url';

const Vue = require('vue')//引入第三方库
const Router = require('vue-router')//引入第三方库
Vue.use(Router)
export default new Router({
  // mode: 'history',  // 去掉路由#
  routes: [
    {
      path: '/',
      name: 'reviewCarHome',
      component(resolve) {//路由懒加载
        require(['@/views/reviewCar'], resolve)
      }
    }, {
      path: '/reviewCar',
      name: 'reviewCar',
      component(resolve) {
        require(['@/views/placeOrder'], resolve)
      }
    },
    {
      path: '/orderList',
      name: 'orderList',
      component(resolve) {
        require(['@/views/orderList/order'], resolve)
      }
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component(resolve) {
        require(['@/views/orderList/orderDetail'], resolve)
      }
    },
    {
      path: '/editOrder',
      name: 'editOrder',
      component(resolve) {
        require(['@/views/orderList/editOrder'], resolve)
      }
    }
    , {
      path: '/address',
      name: 'address',
      component(resolve) {
        require(['@/views/placeOrder/address'], resolve)
      }
    }
    , {
      path: '/whoseCarAgency',
      name: 'whoseCarAgency',
      component(resolve) {
        require(['@/views/whoseCarAgency'], resolve)
      }
    }, {
      path: '/myCarPlate',
      name: 'myCarPlate',
      component(resolve) {
        require(['@/views/myCarPlate'], resolve)
      }
    }
    , {
      path: '/payPage',
      name: 'payPage',
      component(resolve) {
        require(['@/views/payPage'], resolve)
      }
    }
    , {
      path: '/carType',
      name: 'carType',
      component(resolve) {
        require(['@/views/carType'], resolve)
      }
    }
    , {
      path: '/typeDtail',
      name: 'typeDtail',
      component(resolve) {
        require(['@/views/carType/typeDtail'], resolve)
      }
    }
    , {
      path: '/instructions',
      name: 'instructions',
      component(resolve) {
        require(['@/views/reviewCar/instructions'], resolve)
      }
    }, {
      path: '/confirmOrder',
      name: 'confirmOrder',
      component(resolve) {
        require(['@/views/confirmOrder'], resolve)
      }
    },
    // }, {
    //   path: '/uploadData',
    //   name: 'uploadData',
    //   component(resolve) {
    //     require(['@/views/boXunEtc/uploadData'], resolve)
    //   }
    // }, {
    //   path: '/mailingInformation',
    //   name: 'mailingInformation',
    //   component(resolve) {
    //     require(['@/views/boXunEtc/mailingInformation'], resolve)
    //   }
    // }
    // , {
    //   path: '/boXunEtc',
    //   name: 'boXunEtc',
    //   component(resolve) {
    //     require(['@/views/boXunEtc'], resolve)
    //   }
    // }
    // , {
    //   path: '/chooseBankCard',
    //   name: 'chooseBankCard',
    //   component(resolve) {
    //     require(['@/views/boXunEtc/chooseBankCard'], resolve)
    //   }
    // }, {
    //   path: '/agreement',
    //   name: 'agreement',
    //   component(resolve) {
    //     require(['@/views/boXunEtc/agreement'], resolve)
    //   }
    // }, {
    //   path: '/exemptionCheck',
    //   name: 'exemptionCheck',
    //   component(resolve) {
    //     require(['@/views/exemptionCheck'], resolve)
    //   }
    // }, {
    //   path: '/uploadFile',
    //   name: 'uploadFile',
    //   component(resolve) {
    //     require(['@/views/exemptionCheck/uploadFile'], resolve)
    //   }
    // }, {
    //   path: '/uploadFile2',
    //   name: 'uploadFile2',
    //   component(resolve) {
    //     require(['@/views/exemptionCheck/uploadFile2'], resolve)
    //   }
    // }, {
    //   path: '/mailInfo',
    //   name: 'mailInfo',
    //   component(resolve) {
    //     require(['@/views/exemptionCheck/mailInfo'], resolve)
    //   }
    // }, {
    //   path: '/wxPaySuccess',
    //   name: 'wxPaySuccess',
    //   component(resolve) {
    //     require(['@/views/exemptionCheck/wxPaySuccess'], resolve)
    //   }
    // },
    {
      path: '/coupon',
      name: 'coupon',
      component(resolve) {
        require(['@/views/coupon'], resolve)
      }
    }, {
      path: '/error',
      name: 'error',
      component(resolve) {
        require(['@/views/coupon/404'], resolve)
      }
    }, {
      path: '/nationalDay',
      name: 'nationalDay',
      component(resolve) {
        require(['@/views/nationalDay/index'], resolve)
      }
    }, {//优惠券列表
      path: '/couponList',
      name: 'couponList',
      component(resolve) {
        require(['@/views/coupon/couponList'], resolve)
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js